module.exports = __webpack_public_path__ + "img/full7-min.234534e3.png";